
const basicconfig = {

  //////////////////////////
  //    AUTH
  //////////////////////////

  branchtype: {
    service: {
      name: 'branchtype',
      title: 'Branch Type',
    }
  },

  // gender: {
  //   service:{
  //     name:'gender',
  //     title:'Gender',
  //   }
  // },

  version: {
    service: {
      name: 'version',
      title: 'App Version',
    }
  },
  //////////////////////////
  //    CORE
  //////////////////////////

  country: {
    service: {
      name: 'country',
      title: 'Country',
    }
  },

  currency: {
    service: {
      name: 'currency',
      title: 'Currency',
    }
  },

  dashtab: {
    service: {
      name: 'dashtab',
      title: 'Dash Tabs'
    },
    create: false
  },
  dashtype: {
    service: {
      name: 'dashtype',
      title: 'Dash Type',
    }
  },

  // devicetype: {
  //   service:{
  //     name:'devicetype',
  //     title:'Device Type',
  //   }
  // },

  gender: {
    service: {
      name: 'gender',
      title: 'Gender',
    }
  },

  idtype: {
    service: {
      name: 'idtype',
      title: 'ID Type',
    }
  },

  region: {
    service: {
      name: 'region',
      title: 'Region',
    }
  },

  report: {
    service: {
      name: 'report',
      title: 'Reports',
    }
  },

  //////////////////////////
  //    PLATFORM 
  //////////////////////////

  activitystate: {
    service: {
      name: 'activitystate',
      title: 'Activity State',
    }
  },

  activitytype: {
    service: {
      name: 'activitytype',
      title: 'Activity Type',
    }
  },

  customertype: {
    service: {
      name: 'customertype',
      title: 'Customer Type',
    }
  },

  devicetype: {
    service: {
      name: 'devicetype',
      title: 'Device Type',
    }
  },

  eventstate: {
    service: {
      name: 'eventstate',
      title: 'Event State',
    }
  },

  eventtype: {
    service: {
      name: 'eventtype',
      title: 'Event Type',
    }
  },

  notificationstate: {
    service: {
      name: 'notificationstate',
      title: 'Notification State',
    }
  },

  notificationtype: {
    service: {
      name: 'notificationtype',
      title: 'Notification Type',
    }
  },

  requeststate: {
    service: {
      name: 'requeststate',
      title: 'Request State',
    }
  },

  requesttype: {
    service: {
      name: 'requesttype',
      title: 'Request Type',
    }
  },

  reviewstate: {
    service: {
      name: 'reviewstate',
      title: 'Review State',
    }
  },

  reviewtype: {
    service: {
      name: 'reviewtype',
      title: 'Review Type',
    }
  },
  messagetype: {
    service: {
      name: 'messagetype',
      title: 'Message Type',
    }
  },
  messagemode: {
    service: {
      name: 'messagemode',
      title: 'Message Mode',
    }
  },
  messagechannel: {
    service: {
      name: 'messagechannel',
      title: 'Message Channel',
    }
  },

  //////////////////////////
  //    API
  //////////////////////////


  //////////////////////////
  //    AGENCY
  //////////////////////////

  // agency: {
  //   service:{
  //     name:'agency',
  //     title:'Agency',
  //   }
  // },


  //////////////////////////
  //    UPLOAD
  //////////////////////////

  filegroup: {
    service: {
      name: 'filegroup',
      title: 'File Group',
    }
  },

  paramgroup: {
    service: {
      name: 'paramgroup',
      title: 'Parameter Group',
    }
  },

  paramstatus: {
    service: {
      name: 'paramstatus',
      title: 'Parameter Status',
    }
  },

  //////////////////////////
  //    CONTENT
  //////////////////////////

  uidevice: {
    service: {
      name: 'uidevice',
      title: 'UI Device',
    }
  },

  uidoc: {
    service: {
      name: 'uidoc',
      title: 'UI Document',
    }
  },

  uilang: {
    service: {
      name: 'uilang',
      title: 'UI Language',
    }
  },

  uipage: {
    service: {
      name: 'uipage',
      title: 'UI Page',
    }
  },

  uisection: {
    service: {
      name: 'uisection',
      title: 'UI Section',
    }
  },

  orgtype: {
    service: {
      name: 'orgtype',
      title: 'Organization Type',
    }
  },

  linktype: {
    service: {
      name: 'linktype',
      title: 'Link Type',
    }
  },

  linkstate: {
    service: {
      name: 'linkstate',
      title: 'Link State',
    }
  }

};

export { basicconfig };
